import { render } from "./HomeProduct.vue?vue&type=template&id=21d9ab82&scoped=true"
import script from "./HomeProduct.vue?vue&type=script&lang=js"
export * from "./HomeProduct.vue?vue&type=script&lang=js"

import "./HomeProduct.vue?vue&type=style&index=0&id=21d9ab82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21d9ab82"

export default script